import { Injectable } from "@angular/core";
import {
  collection,
  Firestore,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from "@angular/fire/firestore";
import { from, Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ComprasService {
  itemCustomer!: Observable<any[]>;
  private collectionName = "cashback";
  constructor(private firestore: Firestore) {}

  async getCustomerAsync(idCustomer: string) {
    const customersRef = collection(this.firestore, "customers");
    const q = query(customersRef, where("uid", "==", idCustomer), limit(1));
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      return querySnapshot.docs[0].data();
    }
    return null;
  }

  private dateTimeMillis(value: any): number {
    if (!value) return 0;
    if (typeof value.toMillis === "function") return value.toMillis();
    if (value.seconds != null) return value.seconds * 1000;
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  private isMissingIndexError(error: any): boolean {
    const message = String(error?.message ?? error ?? "");
    return (
      error?.code === "failed-precondition" ||
      message.includes("requires an index") ||
      message.includes("The query requires an index")
    );
  }

  // Lista as últimas compras da loja
  getCompras(): Observable<any[]> {
    const companyId = localStorage.getItem("_companyId");
    if (!companyId) return of([]);

    return from(this.fetchCompras(companyId));
  }

  private async fetchCompras(companyId: string): Promise<any[]> {
    const checkinRef = collection(this.firestore, this.collectionName);

    let rows: any[] = [];
    try {
      const snapshot = await getDocs(
        query(
          checkinRef,
          where("companyId", "==", companyId),
          orderBy("dateTime", "desc"),
          limit(10)
        )
      );
      rows = snapshot.docs.map((docSnap) => ({
        id: docSnap.id,
        ...docSnap.data(),
      }));
    } catch (error) {
      if (!this.isMissingIndexError(error)) throw error;

      const snapshot = await getDocs(
        query(checkinRef, where("companyId", "==", companyId))
      );
      rows = snapshot.docs
        .map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }))
        .sort(
          (a: any, b: any) =>
            this.dateTimeMillis(b.dateTime) - this.dateTimeMillis(a.dateTime)
        )
        .slice(0, 10);
    }

    return Promise.all(
      rows.map(async (row) => {
        try {
          const customer = await this.getCustomerAsync(row["customerId"]);
          return { ...row, customer };
        } catch {
          return { ...row, customer: null };
        }
      })
    );
  }
}
